// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "owa." + {"8458":"today","71869":"styles"}[chunkId] + ".p." + {"8458":"b10de3f8","71869":"4ec44aea"}[chunkId] + ".css";
};